export default __webpack_public_path__ + "static/media/advanced_search_closed.15804bf7.svg";